import { useTranslation } from 'next-i18next'
import {
  Box,
  Button,
  Column,
  Columns,
  Dialog,
  IconCheckCircle,
  List,
  Stack,
  Text
} from '@machobear/design-system'

import ENV_VARS from '@/config'
import useCurrentSession from '@/hooks/use-current-session'

import * as styles from './styles.css'
import { ReactComponent as TenantIllustration } from './tenant-illustration.svg'

const { DASHBOARD_URL } = ENV_VARS

const WelcomeUserModal = ({
  visible,
  onClose
}: {
  visible: boolean
  onClose: () => void
}) => {
  const { t } = useTranslation()
  const session = useCurrentSession()

  const firstName = session?.first_name
  const title = firstName
    ? t('r.welcome_modal.view.welcome_name.title', {
        defaultValue: 'Welcome to liv.rent, {{ firstName }}!',
        firstName
      })
    : t('r.welcome_modal.view.welcome.title', 'Welcome to liv.rent!')

  const Illustration = () => (
    <Box className={styles.imageWrapperStyle}>
      <TenantIllustration />
    </Box>
  )

  return (
    <Dialog
      width="small"
      id="welcome-user-modal"
      title={title}
      description={
        <Text>
          {t(
            'r.welcome_modal.view.welcome.text',
            'With a free liv.rent account, you can:'
          )}
        </Text>
      }
      open={visible}
      onClose={onClose}
      illustration={<Illustration />}
    >
      <Stack space="xxlarge">
        <List type="icon" icon={<IconCheckCircle tone="positive" />}>
          <Text tone="secondary">
            {t(
              'r.welcome_modal.view.welcome_list_1.text',
              'Apply to multiple listings with a single application'
            )}
          </Text>
          <Text>
            {t(
              'r.welcome_modal.view.welcome_list_2.text',
              'Stand out on applications with the Trust Score'
            )}
          </Text>
          <Text>
            {t(
              'r.welcome_modal.view.welcome_list_3.text',
              'Get verified – Verified renters are 77% more likely to secure a rental'
            )}
          </Text>
        </List>
        <Columns space="gutter" collapseBelow="tablet">
          <Column width="1/2">
            <Button
              variant="ghost"
              id="web-user-search-listings-button"
              onClick={() => {
                onClose()
                window.open('/rental-listings')
              }}
            >
              {t(
                'r.welcome_modal.view.search_listings.button',
                'Search Listings'
              )}
            </Button>
          </Column>
          <Column>
            <Button
              onClick={() => {
                onClose()
                window.open(`${DASHBOARD_URL}/profile`)
              }}
              id="web-user-complete-profile-button"
            >
              {t(
                'r.welcome_modal.view.complete_profile.button',
                'Complete Profile'
              )}
            </Button>
          </Column>
        </Columns>
      </Stack>
    </Dialog>
  )
}

export default WelcomeUserModal
